export default __webpack_public_path__ + "static/media/NoDataFound.68e289d1.png";